import { render, staticRenderFns } from "./facets-configuration-list.component.vue?vue&type=template&id=fe103310&scoped=true"
import script from "./facets-configuration-list.component.vue?vue&type=script&lang=ts"
export * from "./facets-configuration-list.component.vue?vue&type=script&lang=ts"
import style0 from "./facets-configuration-list.component.vue?vue&type=style&index=0&id=fe103310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe103310",
  null
  
)

export default component.exports